import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import './table.scss';
export default class Table extends React.Component {
    render() {
        const { columns, rows } = convertData(this.props.data);
        return (React.createElement(ReactTable, { data: rows, columns: columns, showPagination: false, pageSize: rows.length, defaultPageSize: rows.length, className: "-striped -highlight" }));
    }
}
function convertData(data) {
    const colMap = {
        name: 'Name',
        type: 'Type',
        value: 'Value',
    };
    const rows = Object.keys(data).map((k) => {
        const o = data[k];
        if (o instanceof Array || !(o instanceof Object)) {
            const type = o instanceof Array ? 'array' : typeof o;
            return { name: k, value: JSON.stringify(o), type };
        }
        else if (o instanceof Object) {
            const values = Object.keys(o).reduce((obj, oKey) => {
                if (!colMap[oKey]) {
                    colMap[oKey] = oKey.substr(0, 1).toUpperCase() + oKey.substr(1, oKey.length - 1);
                }
                obj[oKey] = JSON.stringify(o[oKey]);
                return obj;
            }, {});
            return Object.assign({ name: k }, values);
        }
        return data;
    });
    return {
        columns: [
            {
                headerStyle: { display: 'none' },
                columns: Object.keys(colMap).reduce((cols, k) => {
                    const col = {
                        Header: colMap[k],
                        accessor: k,
                    };
                    if (col.accessor === 'name') {
                        col.maxWidth = 140;
                    }
                    if (col.accessor === 'type') {
                        col.maxWidth = 100;
                    }
                    return [...cols, col];
                }, []),
            },
        ],
        rows,
    };
}
